import { SectionAIActions } from "../SectionAIActions/SectionAIActions";
import { SectionCallType } from "../SectionCallType/SectionCallType";
import { SectionCallUuid } from "../SectionCallUuid/SectionCallUuid";
import { SectionDisconnectedBy } from "../SectionDisconnectedBy/SectionDisconnectedBy";
import { SectionNumber } from "../SectionNumber/SectionNumber";
import { SectionParticipants } from "../SectionParticipants/SectionParticipants";
import { SectionTags } from "../SectionTags/SectionTags";
import { SectionTiming } from "../SectionTiming/SectionTiming";

export function CallSection() {
  return (
    <div className="flex flex-col gap-6" data-test="call-section">
      <SectionTags />
      <SectionCallType />
      <SectionTiming />
      <SectionParticipants />
      <SectionNumber />
      <SectionDisconnectedBy />
      <SectionCallUuid />
      <SectionAIActions />
    </div>
  );
}
